(function() {
  "use strict";

    angular.module("eSign")
    .directive("signTaskListItem", ['$window', function($window) {
      return {
        restrict: 'E',
        replace: 'true',
        templateUrl: 'templates/TaskItem.html',
        link: function(scope, element, attrs) {
          scope.openSignTask = function() {
            if (scope.signTaskSelected) {
              scope.signTaskSelected(scope.signTask);
            }
          }
          scope.deleteSignTask = function() {
            if (scope.signTaskDeleted) {
              scope.signTaskDeleted(scope.signTask);
            }
          }
        },
        scope: {
          signTask: '=',
          signTaskSelected: '=',
          signTaskDeleted: '='
        }
      }
    }]);
}());
